import React, { useEffect, useState } from 'react'
import styles from './style.module.scss'
import { FormWrapper } from '@Root/HOCs'
import { Field } from '@Root/components'
import { useError, useToggle } from '@Root/hooks'

const titles = {
  onEdit: 'Edit Qualification Award Accreditation',
  onRead: 'Qualification Award Accreditation Details',
  onCreate: 'Create Qualification Award Accreditation',
}

export const QualificationAwardAccreditationForm = ({
  canEdit,
  canDelete,
  onDelete,
  onSave,
  onCancel,
  isNew,
  initialValue,
  isLoading,
  isSuccess,
  options,
  descriptions,
  onOpenDescriptionModal,
}) => {
  const [data, setData] = useState({})
  const { errors, setError } = useError()
  const [isEditable, toggleEditable] = useToggle(Boolean(isNew))

  useEffect(() => {
    if (isSuccess) toggleEditable()
  }, [isSuccess])

  useEffect(() => {
    if (initialValue) setData(initialValue)
  }, [initialValue])

  const validateForm = () => {
    const { accreditation_id } = data
    if (!accreditation_id) {
      setError('accreditation_id', 'Required')
      return false
    }
    return true
  }

  const onChangeValue = field => value => {
    setData(prevState => ({ ...prevState, [field]: value }))
  }

  const onChangeMode = () => {
    toggleEditable()
  }

  const onCancelEditMode = () => {
    onChangeMode()
    setData(initialValue)
  }

  const onSubmitForm = () => {
    if (!validateForm()) return
    onSave(data)
  }

  const onCancelEdit = () => {
    if (!isNew) {
      onCancelEditMode()
      return
    }
    onCancel()
  }

  const { accreditation_id, id } = data
  const { accreditationids } = options
  const { onCreate, onEdit, onRead } = titles
  return (
    <div className={styles.form}>
      <FormWrapper
        buttons={isEditable ? ['cancel', ...(canDelete ? ['delete'] : []), 'save'] : []}
        buttonsNames={[{ button: 'delete', name: 'Delete this qualification award accreditation' }]}
        buttonsAreDisabled={isLoading}
        isSpinning={isLoading}
        clickCancelButtonHandler={onCancelEdit}
        clickDeleteButtonHandler={onDelete}
        clickSaveButtonHandler={onSubmitForm}
        editTitle={onEdit}
        readTitle={onRead}
        createTitle={onCreate}
        clickToggleEditModeButtonHandler={onChangeMode}
        isEditable={isEditable}
        canEdit={canEdit}
        isCreate={isNew}
        idForm={id ? `qualification_award_accreditation_details_${id}` : null}
        isSuccess={isSuccess}
      >
        <div className={styles.grid}>
          <div className={styles.column}>
            <div className={styles.row}>
              <Field
                label={'Accreditation identifier'}
                classNames={!isEditable ? ['borderless'] : []}
                style={{ width: 260 }}
                value={accreditation_id}
                field={'select'}
                onChange={onChangeValue('accreditation_id')}
                placeholder='Accreditation identifier'
                isDisabled={!isEditable}
                options={accreditationids}
                maxLength={5}
                optionsStyle={{ width: 260 }}
                error={errors.accreditation_id}
                description={descriptions?.accreditation_id}
                onOpenDescriptionModal={onOpenDescriptionModal}
                isRequired
              />
            </div>
          </div>
        </div>
      </FormWrapper>
    </div>
  )
}
